import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext.js";
import Cards from "../../components/common/cards/index.js";
import api from "../../constants/api.js";
import LoadingIndicator from "../../utils/loading/index.js";

const Dashboard = () => {
  const [cardsData, setCardsData] = useState(null);
  const [loading, setLoading] = useState(false)


  useEffect(() => {
    setLoading(true)
    api.diagnostics.getAll()
      .then(data => { setCardsData(data?.data); setLoading(false) })
      .catch(error => { console.error(error); setLoading(false) });
  }, []);
  return (
    <>
      <LoadingIndicator isloading={loading} />
      <Cards data={cardsData} />
    </>
  );
};

export default Dashboard